const providerCard = () => {
    const $$$ = document.querySelectorAll.bind(document);

    // on click for Show Featured Plan Details
    $$$('.provider-extra__plans').forEach((i) => {
        i.addEventListener('click', () => {
            const providerName = i
                .querySelector('.close-plans')
                .getAttribute('data-for');
            window.dataLayer.push({
                event: 'showProviderPlans',
                provider: providerName,
            });
        });
    });
};

export { providerCard };
